import { api } from './api';
import { Credit, Invoice } from '../types';

export interface CreateCreditRequest {
  invoiceId: string;
  amount: number; // cents
  reason: string;
  internalNotes?: string; // Hidden from client portal
}

export interface CreateCreditResponse {
  credit: Credit;
  invoice: Invoice;
}

export interface VoidCreditResponse {
  credit: Credit;
  invoice: Invoice;
}

export const creditsApi = {
  create: async (data: CreateCreditRequest): Promise<CreateCreditResponse> => {
    return api.post<CreateCreditResponse>('/credits', data);
  },

  void: async (id: string, reason?: string): Promise<VoidCreditResponse> => {
    return api.post<VoidCreditResponse>(`/credits/${id}/void`, { reason });
  },
};
